import './_filter-clear.scss';
import component from './filter-clear';

export default component;
